var React = require('react');

function MetaData({ updatedDate, pubDate, pubType, pubNumber, readerGui}) {
    return (
        <div className="pubr-main__meta" lang={readerGui.guiLang}>
            <span className="pubr-main__meta__item"> {readerGui.publicationTypeText}: {pubType}</span>
            <span className="pubr-main__meta__item"> {readerGui.reportText} {pubNumber}</span>
            <span className="pubr-main__meta__item">{readerGui.publishedText}: {pubDate}</span>
            {updatedDate && 
                <span className="pubr-main__meta__item">{readerGui.updatedText}: {updatedDate}</span>
            }            
        </div>
    )
}

module.exports = MetaData;



// WEBPACK FOOTER //
// ./src/modules/reader/components/MetaData.js